const initState = {};
const ReloadGridReducer = (state = initState, action) => {
    // console.log("ReloadGridReducer",action.type,{...state?.ReloadGridReducer, ...action.payload})
    switch(action.type) {
        case 'ReloadGridAction' : return  {...state?.ReloadGridReducer, ...action.payload} ;
        default: return state;
    }
}
export default ReloadGridReducer;